import { Injectable } from '@angular/core';
import { RoundPipe } from '../../core/pipes/round.pipe';

interface KeyValue {
  key: string;
  value: string;
}

@Injectable()
export class Conversions {
  constructor(private readonly roundPipe: RoundPipe) {}

  convertValueFromDecimalToPercentage(
    decimal?: KeyValue | number,
    undefinedValue?: number,
    roundTo: number = 2,
  ): number {
    if (!decimal) {
      return undefinedValue ?? 0;
    }
    return <number>this.roundPipe.transform(+decimal * 100, roundTo);
  }

  getSettingValueByKey(settings: KeyValue[], keyName: string): string | undefined {
    return settings.find((row) => row.key === keyName)?.value;
  }
}
